import Vue from 'vue';
import {
  SET_ALL,
  SET_STEP_MODEL,
  SET_INVESTMENT_LIST_ITEM_STATUS,
  SET_INVESTMENT_LIST_ITEM_TAX_AS_READ,
  SET_UPDATES_DOCUMENT_AS_READ,
  UPDATE_INVESTMENT_DATA_BY_ID,
  SET_FINANCIAL_STATEMENTS_AS_READ,
} from './mutation-types';

export default {
  [SET_ALL](state, data) {
    Object.assign(state, data);
    return state;
  },
  [UPDATE_INVESTMENT_DATA_BY_ID](state, { id, data } = {}) {
    if (!id) return state.investmentList;
    const list = state.investmentList.concat(state.investmentListCompletedSuccessful, state.investmentListExited);
    const investment = list.find(item => item.id === id);
    if (!investment) return state.investmentList;
    investment.$setAll(data);
    return state.investmentList;
  },
  [SET_STEP_MODEL](state, model) {
    Vue.set(state.stepModels, model.step, model);
    if (model.step === 'amount') {
      // Reset createModel if model for step amount
      // to avoid strange error 'can not read proxy of undefined'
      state.createModel = {};
      model.$set('number_of_shares', state.investmentData.number_of_shares);
    }
    return state.stepModels;
  },
  [SET_INVESTMENT_LIST_ITEM_STATUS](state, { id, status }) {
    const investment = state.investmentList.find(item => item.id === id);
    if (investment) Vue.set(investment, 'status', status);
  },
  [SET_INVESTMENT_LIST_ITEM_TAX_AS_READ](state, id) {
    state.investmentListCompletedSuccessful.forEach((invest) => {
      if (invest.tax_documents) {
        invest.tax_documents.forEach((doc) => {
          if (String(doc.id) === String(id)) Vue.set(doc, 'read', true);
        });
      }
    });
  },
  [SET_UPDATES_DOCUMENT_AS_READ](state, id) {
    state.investmentListCompletedSuccessful.forEach((invest) => {
      if (invest.farm.updates_document_folder) {
        invest.farm.updates_document_folder.forEach((doc) => {
          if (String(doc.id) === String(id)) Vue.set(doc.meta_data, 'read', true);
        });
      }
    });
  },
  [SET_FINANCIAL_STATEMENTS_AS_READ](state, id) {
    state.investmentListCompletedSuccessful.forEach((invest) => {
      if (invest.farm.financial_statement_document_folder) {
        invest.farm.financial_statement_document_folder.forEach((doc) => {
          if (String(doc.id) === String(id)) Vue.set(doc.meta_data, 'read', true);
        });
      }
    });
  },
};
